import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import I18n from 'i18n-react';
import $ from 'jquery';

import OverviewFlight from '../overviewFlight/OverviewFlight';
import OverviewPriceSummary from '../overviewPriceSummary/OverviewPriceSummary';

import './OverviewPrice.css';

const propTypes = {
  id: PropTypes.string.isRequired,
  alterFlight: PropTypes.bool.isRequired,
  values: PropTypes.shape({
    totalPoints: PropTypes.number.isRequired,
    totalTaxes: PropTypes.number,
    totalTaxesServices: PropTypes.number,
    totalTaxesAndMoney: PropTypes.number,
    totalAdult: PropTypes.number.isRequired,
    totalChildren: PropTypes.number,
    totalInfant: PropTypes.number,
    adultNumber: PropTypes.number,
    childNumber: PropTypes.number,
    infantNumber: PropTypes.number,
    totalMoneyAdult: PropTypes.number,
    totalMoneyChild: PropTypes.number,
    totalMoneyInfant: PropTypes.number
  }),
  departureFlight: PropTypes.shape({
    flightDate: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    flight: PropTypes.shape({
      flightGroup: PropTypes.arrayOf(
        PropTypes.shape({
          flightNumber: PropTypes.number.isRequired,
          origin: PropTypes.string.isRequired,
          destination: PropTypes.string.isRequired,
          departureTime: PropTypes.string.isRequired,
          arrivalTime: PropTypes.string.isRequired,
          dateVariation: PropTypes.number,
          operatingCarrier: PropTypes.string.isRequired,
          throughFlight: PropTypes.bool
        })
      )
    })
  }),
  returnFlight: PropTypes.shape({
    flightDate: PropTypes.string,
    category: PropTypes.string.isRequired,
    flight: PropTypes.shape({
      flightGroup: PropTypes.arrayOf(
        PropTypes.shape({
          flightNumber: PropTypes.number,
          origin: PropTypes.string,
          destination: PropTypes.string,
          departureTime: PropTypes.string,
          arrivalTime: PropTypes.string,
          dateVariation: PropTypes.number,
          operatingCarrier: PropTypes.string,
          throughFlight: PropTypes.bool
        })
      )
    })
  }),
  renderOpen: PropTypes.bool
};

const defaultProps = {
  totalTaxes: null,
  renderOpen: false
};

class OverviewPrice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openDesktop: this.props.renderOpen,
      openMobile: false,
      isPointsPlusMoney: this.props.values.totalMoneyAdult > 0
    };
  }

  componentWillUnmount() {
    this.addScroll();
  }

  formatPoints(value) {
    let formated;
    if (value) {
      formated = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
    return formated;
  }

  formatBRL(value) {
    let formated = '--';
    if (value && value > 0) {
      let integer = value.toFixed(2).split('.');
      integer[0] = integer[0].split(/(?=(?:...)*$)/).join('.');
      formated = integer.join(',');
    }
    return formated;
  }

  openContainer = () => {
    this.setState({
      openDesktop: !this.state.openDesktop,
      openMobile: !this.state.openDesktop
    });

    const icon = $('.OverviewPrice--iconArrow');
    const classRotate = 'OverviewPrice--iconArrowRotate';
    if (!this.state.openDesktop) {
      icon.addClass(classRotate);
    } else {
      icon.removeClass(classRotate);
    }
  };

  closeModal = () => {
    this.setState({
      openMobile: false,
      openDesktop: false
    });
    this.addScroll();
  };

  openModal = () => {
    this.setState({
      openMobile: true,
      openDesktop: true
    });
    this.removeScroll();
  };

  addScroll() {
    $('body').css('overflow-y', 'auto');
  }

  removeScroll() {
    $('body').css('overflow', 'hidden');
  }

  getClassHeightSummaryAndFlight(prefix) {
    const { isPointsPlusMoney } = this.state;
    if (this.props.values.totalInfant > 0) {
      return isPointsPlusMoney ? `${prefix}heightOverviewPlusMoneyInfant` : `${prefix}heightOverviewInfant`;
    } else if (this.props.values.totalChildren) {
      return isPointsPlusMoney ? `${prefix}heightOverviewPlusMoneyChild` : `${prefix}heightOverviewChild`;
    }
    return isPointsPlusMoney ? `${prefix}heightOverviewPlusMoneyAdult` : `${prefix}heightOverviewAdult`;
  }

  renderModalContainer(state) {
    if (state) {
      return (
        <Row className="OverviewPrice__Modal">
          <Col>
            <Row className="OverviewPrice__ModalHeader">
              <Col xs={7} className="OverviewPrice__titleResume">
                {I18n.translate('components.overviewPrice.titleResume')}
              </Col>
              <Col xs={5} className="OverviewPrice--columnIconClosed" onClick={this.closeModal}>
                <div className="OverviewPrice--iconClosed" />
              </Col>
            </Row>
          </Col>

          <Col className="OverviewPrice__ModalBody">{this.renderContainer(state)}</Col>
        </Row>
      );
    }
  }

  renderContainer(state) {
    const { isPointsPlusMoney } = this.state;
    if (state) {
      return (
        <Row>
          <Col className="OverviewPrice__container">
            <div className="OverviewPrice__flightPriceSummary">
              <Col className={`componentOverviewFlight-overviewFlight ${this.getClassHeightSummaryAndFlight(`overviewFlight`)}`}>
                <OverviewFlight
                  id="overviewFlight"
                  ref={c => (this.overviewFlight = c)}
                  alterFlight={this.props.alterFlight}
                  departureFlight={this.props.departureFlight}
                  returnFlight={this.props.returnFlight}
                />
              </Col>
              <Col className={`componentOverviewPriceSummary-overviewPriceSummary ${this.getClassHeightSummaryAndFlight(`overviewPriceSummary`)}`}>
                <OverviewPriceSummary
                  id="overviewPriceSummary"
                  ref={c => (this.overviewPriceSummary = c)}
                  totalAdult={this.formatPoints(this.props.values.totalAdult)}
                  totalChildren={this.formatPoints(this.props.values.totalChildren)}
                  totalInfant={this.formatPoints(this.props.values.totalInfant)}
                  totalTaxes={this.formatBRL(this.props.values.totalTaxesServices)}
                  totalTaxesAndMoney={this.props.values.totalTaxesAndMoney}
                  totalMoneyAdult={this.props.values.totalMoneyAdult}
                  totalMoneyChild={this.props.values.totalMoneyChild}
                  totalMoneyInfant={this.props.values.totalMoneyInfant}
                  adultNumber={this.props.values.adultNumber}
                  childNumber={this.props.values.childNumber}
                  infantNumber={this.props.values.infantNumber}
                />
              </Col>
            </div>

            <div className="OverviewPrice__flightPriceValues">
              {!isPointsPlusMoney ? this.renderOnlyPointsAndTaxes() : this.renderPointsPlusMoneyAndTaxes()}
            </div>
          </Col>
        </Row>
      );
    }
  }

  renderPointsPlusMoneyAndTaxes() {
    return (
      <div>
        {this.renderTaxes(true)}
        {this.renderPointsOrPointsPlusMoney(true)}
      </div>
    );
  }

  renderOnlyPointsAndTaxes() {
    return (
      <div>
        {this.renderPointsOrPointsPlusMoney(false)}
        {this.renderTaxes(false)}
      </div>
    );
  }

  renderPointsOrPointsPlusMoney(isPointsPlusMoney) {
    return (
      <Row className={!isPointsPlusMoney ? "OverviewPrice__total OverviewPrice__totalPoints" : "OverviewPrice__total OverviewPrice__totalPoints OverviewPrice__heightPointPlusMoney"}>
        <Col xs={6} className="OverviewPrice__columnTotalLabel">
          <label className={!isPointsPlusMoney ? "OverviewPrice__totalLabel" : "OverviewPrice__totalLabel OverviewPrice__totalLabelMargin"} >
            {!isPointsPlusMoney ?
              I18n.translate('components.overviewPrice.messageTotalPoints')
              :
              I18n.translate('pointsPlusMoney.priceSummary.messageTotalPointsPlusMoney')
            }
          </label>
        </Col>
        <Col xs={6} className="OverviewPrice__columnTotalPoints">
          <label className={!isPointsPlusMoney ? "OverviewPrice__totalValue" : "OverviewPrice__totalValue OverviewPrice__totalValueMargin"} >
            {!isPointsPlusMoney ?
              this.formatPoints(this.props.values.totalPoints)
              :
              <div>
                <Row>{I18n.translate('pointsPlusMoney.priceSummary.points', {
                  points: this.formatPoints(this.props.values.totalPoints)
                })}</Row>
                <Row>{I18n.translate('pointsPlusMoney.priceSummary.money', {
                  money: this.formatBRL(this.props.values.totalTaxesAndMoney)
                })}</Row>
              </div>
            }
          </label>
          <span> </span>
          {!isPointsPlusMoney ? (
            <label className="OverviewPrice__totalCurrency">
              {I18n.translate('components.overviewPrice.currencyPoints')}
            </label>
          ) : null
          }
        </Col>
      </Row>
    );
  }

  renderTaxes(isPointsPlusMoney) {
    return (
      <Row className="OverviewPrice__total OverviewPrice__totalTaxes">
        <Col xs={6} className="OverviewPrice__columnTotalLabel">
          <label className="OverviewPrice__totalLabel">
            {!isPointsPlusMoney ?
              I18n.translate('components.overviewPrice.messageTotalTaxes')
              :
              I18n.translate('pointsPlusMoney.priceSummary.messageTotalTaxes')
            }
          </label>
        </Col>
        <Col xs={6} className="OverviewPrice__columnTotalTaxes">
          <label className="OverviewPrice__totalCurrency">
            {I18n.translate('components.overviewPrice.currencyBRL')}
          </label>
          <span> </span>
          <label className="OverviewPrice__totalValue">
            {this.formatBRL(this.props.values.totalTaxes)}
          </label>
        </Col>
      </Row>
    );
  }

  renderContentClosed(event) {
    return (
      <Row className="OverviewPrice__content OverviewPrice__contentClosed" onClick={event}>
        <Col xs={11} className="OverviewPrice__columnContent">
          <Row>
            <Col xsHidden md={6}>
              <label className="OverviewPrice__title">
                {I18n.translate('components.overviewPrice.totalPoints')}
              </label>
            </Col>
            <Col xsHidden md={6}>
              <label className="OverviewPrice__title">
                {I18n.translate('components.overviewPrice.totalTaxes')}
              </label>
            </Col>
            <Col xs={12} md={6}>
              <label className="OverviewPrice__totalPoints">
                <label className="OverviewPrice__value">
                  {this.formatPoints(this.props.values.totalPoints)}
                </label>
                <span> </span>
                <label className="OverviewPrice__currency">
                  {I18n.translate('components.overviewPrice.currencyPoints')}
                </label>
              </label>
            </Col>
            <Col xs={12} md={6}>
              <label className="OverviewPrice__totalTaxes">
                <label className="OverviewPrice__currency">
                  {I18n.translate('components.overviewPrice.currencyBRL')}
                </label>
                <span> </span>
                <label className="OverviewPrice__value">
                  {this.formatBRL(this.props.values.totalTaxes)}
                </label>
              </label>
            </Col>
          </Row>
        </Col>
        <Col xs={1} className="OverviewPrice--columnIconArrow">
          <i className="icon-caret-down OverviewPrice--iconArrow" />
        </Col>
      </Row>
    );
  }

  renderContentClosedPlusMoney(event) {
    return (
      <Row className="OverviewPrice__content OverviewPrice__contentClosed" onClick={event}>
        <Col xs={11} className="OverviewPrice__columnContentPointsPlusMoney">
          <Row>
            <Col xs={12} md={6}>
              <Col className="OverviewPrice__titlePlusMoney">
                {I18n.translate('pointsPlusMoney.priceSummary.messageLabelTotal')}
              </Col>
              <Col className="OverviewPrice__totalPointsPlusMoney">
                {I18n.translate('pointsPlusMoney.priceSummary.messageOverviewPriceClosed', {
                  points: this.formatPoints(this.props.values.totalPoints),
                  money: this.formatBRL(this.props.values.totalTaxesAndMoney)
                })}
              </Col>
            </Col>
          </Row>
        </Col>
        <Col xs={1} className="OverviewPrice--columnIconArrow">
          <i className="icon-caret-down OverviewPrice--iconArrow" />
        </Col>
      </Row>
    );
  }

  renderContentOpened(event) {
    return (
      <Row className="OverviewPrice__content OverviewPrice__contentOpened" onClick={event}>
        <Col xs={11} className="OverviewPrice__titleResume">
          {I18n.translate('components.overviewPrice.titleResume')}
        </Col>
        <Col xs={1} className="OverviewPrice--columnIconArrow">
          <i className="icon-caret-down OverviewPrice--iconArrow" />
        </Col>
      </Row>
    );
  }

  renderHeader(event, state) {
    const { isPointsPlusMoney } = this.state;
    if (state) {
      return this.renderContentOpened(event);
    } else {
      return !isPointsPlusMoney ? this.renderContentClosed(event) : this.renderContentClosedPlusMoney(event);
    }
  }

  render() {
    return (
      <div id={this.props.id} className="OverviewPrice">
        <Row>
          <Col xsHidden md={12} className="OverviewPrice_large">
            {this.renderHeader(this.openContainer, this.state.openDesktop)}
            {this.renderContainer(this.state.openDesktop)}
          </Col>
          <Col smHidden mdHidden lgHidden md={12} className="OverviewPrice_small">
            {this.renderHeader(this.openModal, this.state.openMobile)}
            {this.renderModalContainer(this.state.openMobile)}
          </Col>
        </Row>
      </div>
    );
  }
}

OverviewPrice.propTypes = propTypes;
OverviewPrice.defaultProps = defaultProps;

export default OverviewPrice;



// WEBPACK FOOTER //
// ./src/components/overviewSearchBar/overviewPrice/OverviewPrice.jsx